import { render, staticRenderFns } from "./composer-ditar-espectro.vue?vue&type=template&id=0284312c&scoped=true&"
import script from "./composer-ditar-espectro.vue?vue&type=script&lang=js&"
export * from "./composer-ditar-espectro.vue?vue&type=script&lang=js&"
import style0 from "./composer-ditar-espectro.vue?vue&type=style&index=0&id=0284312c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284312c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0284312c')) {
      api.createRecord('0284312c', component.options)
    } else {
      api.reload('0284312c', component.options)
    }
    module.hot.accept("./composer-ditar-espectro.vue?vue&type=template&id=0284312c&scoped=true&", function () {
      api.rerender('0284312c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-ditar-espectro/composer-ditar-espectro.vue"
export default component.exports